define('fukit/service/loading.service',['require','exports','module','underscore','backbone','nprogress','../view/block/loading.dimmer.view','../view/block/error.dimmer.view','../view/block/permission.dimmer.view','../view/block/product.deactivated.dimmer.view','../helpers/error.util','jquery'],function(require, exports, module) {
  //prettier-ignore
  var _                            = require('underscore'),
      Backbone                     = require('backbone'),
      NProgress                    = require('nprogress'),
      LoadingDimmerView            = require('../view/block/loading.dimmer.view'),
      ErrorDimmerView              = require('../view/block/error.dimmer.view'),
      PermissionDimmerView         = require('../view/block/permission.dimmer.view'),
      ProductDeactivatedDimmerView = require('../view/block/product.deactivated.dimmer.view'),
      ErrorUtil                    = require('../helpers/error.util'),
      jQuery                       = require('jquery');

  var LoadingService = _.extend({}, Backbone.Events, {
    channelName: 'loadingService',

    radioRequests: {
      stopLoading: 'stopLoading',
      startLoading: 'startLoading',
    },

    radioEvents: {
      'app configure': 'onAppConfigure',
      'AppKit.controllerService start': 'onControllerStart',
    },

    configureNProgress: function() {
      if (!this.nProgressconfigured && document.querySelector('.shared-header')) {
        NProgress.configure({
          showSpinner: false,
          parent: '.shared-header',
          template:
            '<div class="bar" role="bar"><div class="peg"></div></div><div class="nprogress-loading"></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>',
        });
        this.nProgressconfigured = true;
      }
      return this.nProgressconfigured;
    },

    onAppConfigure: function() {
      this.dimmerView = new LoadingDimmerView({ visible: false });
      this.errorDimmerView = new ErrorDimmerView({ visible: false });
      this.permissionDimmerView = new PermissionDimmerView({ visible: false });
      this.productDeactivatedDimmerView = new ProductDeactivatedDimmerView({ visible: false });
      this.nProgressconfigured = false;
      this.configureNProgress();
    },

    startNProgress: function() {
      if (this.configureNProgress()) {
        jQuery('.shared-header').removeClass('progress-done');
        jQuery('.shared-header').addClass('inprogress');
        NProgress.start();
      }
    },

    stopNProgress: function() {
      if (this.configureNProgress()) {
        NProgress.set(1);
        NProgress.remove();
        jQuery('.shared-header').addClass('progress-done');
        jQuery('.shared-header').removeClass('inprogress');
      }
    },

    onControllerStart: function(controller) {
      this.stopListening(this.previousController);
      this.previousController = controller;
      this.startLoading();
      this.listenTo(controller, 'started error', function() {
        this.stopLoading();
        this.stopListening(controller);
      });
      this.listenTo(controller, 'error', function(controller, error, options) {
        if (error instanceof ErrorUtil.PermissionError || (error.status && error.xhr.status === 403)) {
          this.permissionDimmerView.visible = true;
        } else if (error instanceof ErrorUtil.ProductDeactivatedError) {
          this.productDeactivatedDimmerView.visible = true;
        } else {
          this.errorDimmerView.visible = true;
        }
      });
    },

    stopLoading: function() {
      this.dimmerView.visible = false;
      this.stopNProgress();
    },

    startLoading: function() {
      this.errorDimmerView.visible = false;
      this.dimmerView.visible = true;
      this.startNProgress();
    },
  });

  module.exports = LoadingService;
});

